<template>
  <div id="app">
      <router-view />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { DEFAULT_LOCALE } from '@/constants/i18n'
import { TEXT_TYPES } from '@/constants/i18n'

export default {
  name: 'App',
  methods: {
    ...mapActions([
      'fetchLocales',
      'setLocale',
      'fetchTranslations'
    ])
  },
  async created() {
    //Load fallback translations
    this.fetchTranslations({ textType: TEXT_TYPES.ITEM, interactionToken: this.interactionInstanceToken, asFallback: true }),
    this.fetchTranslations({ textType: TEXT_TYPES.CHOICE, interactionToken: this.interactionInstanceToken, asFallback: true }),
    this.fetchTranslations({ textType: TEXT_TYPES.INTERACTION_BASE, asFallback: true })
    await this.fetchLocales();
    this.setLocale({ locale: this.$route.query.locale || DEFAULT_LOCALE.id })
    this.$store.commit('SET_APP_READY', true);
  },
};
</script>
<style lang="scss">
body, html {
  height: 100%;
}

#app {
  font-family: 'Open Sans', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $main-font-grey;
  height: 100%;

  @media screen and (min-width: 992px) {
    background: #ffffff;
  }
}
</style>
